import { render, staticRenderFns } from "./initUpdateFeriePermessi.vue?vue&type=template&id=77d22188&"
import script from "./initUpdateFeriePermessi.vue?vue&type=script&lang=js&"
export * from "./initUpdateFeriePermessi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
